import { Card, CardBody, IconButton, LogoVertical } from "@datapay-by-datacom/design-system";
import { IoCloseOutline } from "react-icons/io5";
import { Link, useLocation } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { getBrandName, getLogoUrl } from "../../brand-config";
import { useReleaseBanner } from "../hooks/useReleaseBanner";
import s from "./ReleaseBanner.module.css";

export function ReleaseBanner() {
  const banner = useReleaseBanner();
  const { pathname } = useLocation();

  if (!banner || pathname === "/release-announcements") {
    return null;
  }

  const { announcement, dismiss } = banner;
  const logoUrl = getLogoUrl();

  return (
    <div className={s.wrapper}>
      <Card>
        <CardBody>
          <div className={s.banner}>
            <div className={s.topRow}>
              <div className={s.branding}>
                <div className={s.logo}>
                  {logoUrl ? (
                    <img src={logoUrl} alt={getBrandName()} className={s.logoImg} />
                  ) : (
                    <LogoVertical />
                  )}
                </div>
                <div className={s.brandText}>
                  <span className={s.brandTitle}>Payroll Assistant</span>
                  <span className={s.brandSubtitle}>Powered by {getBrandName()}</span>
                </div>
              </div>

              <div className={s.actions}>
                <IconButton onPress={dismiss} aria-label="Dismiss announcement">
                  <IoCloseOutline size={20} />
                </IconButton>
              </div>
            </div>

            <div className={s.content}>
              <span className={s.date}>
                {new Date(announcement.releaseDate + "T00:00:00").toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" })}
              </span>
              <h3 className={s.title}>{announcement.title}</h3>
              <div className={s.body}>
                <ReactMarkdown
                  remarkPlugins={[remarkGfm]}
                  components={{
                    a: ({ children, href, ...props }) => {
                      if (href && href.startsWith("/")) {
                        return <Link to={href}>{children}</Link>;
                      }
                      return (
                        <a href={href} target="_blank" rel="noopener noreferrer" {...props}>
                          {children}
                        </a>
                      );
                    },
                  }}
                >
                  {announcement.body}
                </ReactMarkdown>
              </div>
            </div>
          </div>

          <p className={s.footer}>
            After you dismiss this announcement you can still view it via{" "}
            <Link to="/settings">Settings</Link> &gt; <Link to="/release-announcements">Release Announcements</Link>
          </p>
        </CardBody>
      </Card>
    </div>
  );
}
